// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"82":"6e3376fc","125":"812f568b"}[chunkId] + ".chunk.css";
};